import { Directive, inject, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';

import { PickList } from 'primeng/picklist';
import { OrderList } from 'primeng/orderlist';

@Directive({
    /* eslint-disable-next-line @angular-eslint/directive-selector */
    selector: 'p-pickList, p-orderList',
    standalone: false
})
export class HisListboxDirective implements OnChanges  {
    private el = inject(ElementRef);


    private pickList = inject(PickList, { optional: true });
    private orderList = inject(OrderList, { optional: true });

    @Input() source: any[] = [];
    @Input() target: any[] = [];
    @Input() value: any[] = [];
    
    ngOnChanges(changes: SimpleChanges): void {
        const srcChanged = !!changes.source;
        const tgtChanged = !!changes.target;

        const orderListValue = !!changes.value;

        queueMicrotask(() => {
            if(this.pickList){
                if (!(srcChanged || tgtChanged)) return;
                const pickListElements = this.pickList.el?.nativeElement as HTMLElement | null;
                if (!pickListElements) return;
                this.clearHighlightClasses(pickListElements);
            }
            if(this.orderList){
                if (!orderListValue) return;
                const orderListElements = this.orderList.el?.nativeElement as HTMLElement | null;
                if (!orderListElements) return;
                this.clearHighlightClasses(orderListElements);
            }
        });
    }

    private clearHighlightClasses(listElements: HTMLElement): void {
        const items = listElements.querySelectorAll<HTMLElement>('.p-listbox-list li');
        items.forEach(item => {
            item.classList.remove('p-highlight');
            item.classList.remove('p-listbox-option-selected');
        });
    }
}
